"use client";

import { useEffect } from "react";

import { Button } from "@/components/ui/button";
import { logger } from "@/lib/logger";

export function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logger.error("Global error", {
      error,
      digest: error.digest,
      boundary: "app/error",
    });
  }, [error]);

  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <div className="w-full max-w-md rounded-lg border p-6">
        <h2 className="mb-2 text-lg font-semibold">Something went wrong</h2>
        <p className="text-muted-foreground mb-4 text-sm">Please try again.</p>
        <Button
          onClick={() => {
            reset();
          }}
        >
          Try again
        </Button>
      </div>
    </div>
  );
}

export default GlobalError;
